'use client';
import Link from 'next/link';
import { ButtonHTMLAttributes, forwardRef } from 'react';
import { useTheme } from 'styled-components';

import { AnalyticsEventName } from '@/api/analytics';
import { sendEventToAnalyticsFn } from '@/helpers/analytics';
import { getSportsHref } from '@/helpers/variables';
import { useServer } from '@/modules/server/context/ServerEnvContext';

import {
  ScTabBarButton,
  ScTabBarButtonProps,
} from '@/components/buttons/styled';

type ClientButtonSportsProps = {
  locale: string;
} & ScTabBarButtonProps &
  ButtonHTMLAttributes<HTMLButtonElement>;

const ClientButtonSports = forwardRef<
  HTMLButtonElement,
  ClientButtonSportsProps
>(({ locale, ...props }, ref) => {
  const { sportsIcon: SportsIcon } = useTheme();
  const { hostname } = useServer();

  const sportsHref = getSportsHref(hostname, locale);

  const handleSportsClick = async (event: React.MouseEvent) => {
    event.preventDefault();

    await sendEventToAnalyticsFn({
      name: AnalyticsEventName.TABBAR__BUTTONS__SPORTS_BUTTON__CLICK,
    });
    if (typeof window !== 'undefined') window.location.replace(sportsHref);
  };

  return (
    <Link href={sportsHref} onClick={handleSportsClick}>
      <ScTabBarButton ref={ref} {...props}>
        <SportsIcon />
      </ScTabBarButton>
    </Link>
  );
});

export default ClientButtonSports;
